module.exports = __webpack_public_path__ + "static/media/track-marketing-privacy.fac2e05b.png";